// components\MQTTClient.tsx

import React, { useEffect } from 'react';
import jwt_decode from 'jwt-decode'; // JWT 디코딩
import MQTTService from './MQTTService';
import { decompressMessage } from './utils/MQTTMessageMapper'; // ✅ 추가

interface MQTTClientProps {
  onMessage: (message: string) => void;
}

const MQTTClient: React.FC<MQTTClientProps> = ({ onMessage }) => {
  const token = localStorage.getItem('token');
  const email = token ? (jwt_decode(token) as { email: string }).email : '';
  const targetTopic = `i2r/${email}/out`;
  const commonTopic = 'i2r/+/out'; // 공통 토픽

  useEffect(() => {
    const mqttClient = MQTTService.getInstance().getClient();

    // 메시지 핸들러 정의
    const handleMessage = (topic: string, message: Buffer) => {
      const messageStr = message.toString();
      // MQTT 메시지 가공하기 전의 원본 메시지 출력
      //console.log(`🧩0 Received message on topic ${topic}: ${messageStr}`);

      try {
        const parsed = JSON.parse(messageStr);
        const decompressed = decompressMessage(parsed); // ✅ 축약 → 전체 변환
        //console.log('🧩1 Decompressed message:', JSON.stringify(decompressed, null, 2));
        // ✅ mac 또는 email이 없으면 무시
        if (!decompressed.mac || !decompressed.email) {
          //console.warn('⚠️ mac 또는 email이 없는 메시지 무시:', decompressed);
          return;
        }

        // ✅ 리액트 상태 업데이트 강제를 위해 타임스탬프 주입 (내용이 같아도 갱신되도록)
        (decompressed as any)._ts = Date.now();

        //console.log('🧩2 Decompressed message:', JSON.stringify(decompressed, null, 2));
        onMessage(JSON.stringify(decompressed));
      } catch (error) {
        console.error('❌ Invalid MQTT message JSON:', messageStr);
      }
    };


    // 공통 토픽 구독
    mqttClient.subscribe(commonTopic, (err) => {
      if (!err) {
        //console.log(`Subscribed to common topic: ${commonTopic}`);
      } else {
        console.error(`Failed to subscribe to common topic: ${commonTopic}`, err);
      }
    });

    // 메시지 핸들러 등록
    mqttClient.on('message', handleMessage);

    return () => {
      // 컴포넌트 언마운트 시 리스너 및 구독 해제
      mqttClient.off('message', handleMessage); // 리스너 제거
      mqttClient.unsubscribe(commonTopic, () => {
        //console.log(`Unsubscribed from common topic: ${commonTopic}`);
      });
    };
  }, [commonTopic, onMessage]);

  //return <div>MQTT 연결 중...</div>;
  return null;
};

export default MQTTClient;
